<template>
  <!-- 頂部導航列 -->
  <!-- <nav class="navbar navbar-expand-lg navbar-light bg-white">
    <div class="container-fluid p-2">
      <router-link class="navbar-brand d-flex align-items-center ms-5" to="/receipt-search">
        <img
          src="@/assets/images/driver/logo.png"
          alt="Logo"
          class="me-2"
          style="height: 40px;"
        />
      </router-link>
    </div>
  </nav> -->

  <!-- 上方深色區塊 -->
  <div class="find-your-reciept">
    <div class="d-flex justify-content-center align-items-center find-your-reciept-title">
      Find your receipt
    </div>
    <div class="d-flex justify-content-center align-items-center find-your-reciept-text">
      Use the form below to download a copy of your receipt
    </div>
  </div>

  <!-- 主內容區塊 -->
  <div class="main">
    <div class="container py-lg-5">
      <div class="row g-3">
        <!-- 左側搜尋表單 -->
        <div class="col-12 col-lg-7 bg-search">
          <div class="row">
            <!-- 日期 -->
            <div class="mb-3 col-12 col-md-6">
              <label for="transactionDate" class="form-label search-text">
                TRANSACTION DATE (TRIP DATE)
              </label>
              <Datepicker1 class="datepicker-here form-control" :format="format" v-model="receiptStore.filters.date" :enable-time-picker="false" data-language="en" placeholder="Select date" />
            </div>

            <!-- 金額 -->
            <div class="mb-3 col-12 col-md-6">
              <label for="transactionAmount" class="form-label search-text">
                TRANSACTION AMOUNT
              </label>
              <input
                v-model="receiptStore.filters.amount"
                type="number"
                class="form-control"
                id="transactionAmount"
                placeholder=""
              />
            </div>

            <!-- 卡號後四碼 -->
            <div class="mb-3">
              <label for="last4Digits" class="form-label search-text">
                LAST 4 DIGITS OF PAYMENT CARD
              </label>
              <input
                v-model="receiptStore.filters.card_last_4_digits"
                type="text"
                class="form-control"
                id="last4Digits"
                placeholder=""
                maxlength="4"
              />
            </div>

            <!-- (示範) PICK-UP LOCATION, DROP-OFF LOCATION，可依需求修改 -->
            <div class="mb-3">
              <label for="pickupLocation" class="form-label search-text">
                PICK-UP LOCATION
              </label>
              <select class="form-select" id="pickupLocation" v-model="receiptStore.filters.pick_up">
                <option value="">Please select</option>
                <option value="Airport">Airport</option>
                <option value="Office">Office</option>
                <option value="Home">Home</option>
                <option value="Hotel">Hotel</option>
                <option value="Suburb">Suburb</option>
              </select>
            </div>

            <div class="mb-4">
              <label for="dropoffLocation" class="form-label search-text">
                DROP-OFF LOCATION
              </label>
              <select class="form-select" id="dropoffLocation" v-model="receiptStore.filters.drop_off">
                <option value="">Please select</option>
                <option value="Airport">Airport</option>
                <option value="Office">Office</option>
                <option value="Home">Home</option>
                <option value="Hotel">Hotel</option>
                <option value="Suburb">Suburb</option>
              </select>
            </div>
          </div>

          <!-- 搜尋按鈕 -->
          <div class="d-flex justify-content-center mt-3">
            <button type="button" class="btn btn-search" @click="search">
              Search again
            </button>
          </div>
        </div>

        <!-- 右側搜尋結果 (step=1) -->
        <div v-if="step === 1" class="col-12 col-lg-4 offset-lg-1 bg-white p-5">
          <h5 class="fw-bold mb-4">Search results</h5>

          <!-- 若無結果，顯示提示，否則列出所有結果 -->
          <div v-if="receiptStore.results.length === 0">
            <p>No results found</p>
          </div>
          <div
            v-else
            v-for="(result, index) in receiptStore.results"
            :key="index"
            class="mb-3"
          >
            <!-- 你可以自由調整顯示格式 -->
            <div class="d-flex justify-content-between">
              <div>
                <!-- 日期與時間 -->
                <div class="result-text mb-2">{{ formatDateTime(result.datetime) }}</div>
                <!-- PICK-UP, DROP-OFF -->
                <div class="result-text">PICKUP: {{ result.pick_up  }}</div>
                <div class="result-text">DROP-OFF: {{ result.drop_off  }}</div>
              </div>
              <div class="d-flex align-items-end">
                <div class="result-amount me-2">${{ result.approved.total }}</div>
                <button class="btn btn-arrow" @click="goToDetail(result)">
                  <img src="@/assets/images/driver/arrow.png" class="arrow-icon" alt="">
                </button>
              </div>
            </div>
            <hr />
          </div>
        </div>

        <!-- 右側單筆明細頁 (step=2) -->
        <div v-if="step === 2 && selectedResult" class="col-12 col-lg-4 offset-lg-1 mb-4">
          <button class="btn-back" @click="stepTo(1)">
            <img src="@/assets/images/driver/backResult.png" class="back-icon me-2" alt="">
            Back to results
          </button>

          <button class="download-box border-0" @click="downloadReceipt">
            Download receipt <img src="@/assets/images/driver/download.png" class="download-icon ms-2" alt="">
          </button>

          <div id="receipt-detail" class="mt-3 bg-white p-3">
            <div class="d-flex justify-content-center mt-2">
              <img src="@/assets/images/driver/logo.png" class="logo-icon" alt="">
            </div>
            <div class="taxi1-pty">TAXI1 PTY LTD</div>
            <div class="taxi1-pty mt-0">
              <a href="https://taxi1.com.au" target="_blank">taxi1.com.au</a>
            </div>
            <div class="tax-invoice">Tax invoice</div>

            <!-- 示例：顯示日期與時間 (datetime) -->
            <div class="row mb-3">
              <div class="col-6 detail-text">
                Date: {{ parseDate(selectedResult.datetime) }}
              </div>
              <div class="col-6 detail-text">
                Time: {{ parseTime(selectedResult.datetime) }}
              </div>
            </div>

            <!-- MID, TID, ABN 等資訊 -->
            <div class="detail-text">MID: {{ selectedResult.mid }}</div>
            <div class="detail-text">TID: {{ selectedResult.tid }}</div>
            <div class="detail-text">DRIVER ABN: {{ selectedResult.abn }}</div>
            <!-- <div class="detail-text">DRIVER ID: {{ selectedResult.driver?.driver_id }}</div> -->
            <div class="detail-text mb-2">PLATE NUMBER: {{ selectedResult.driver?.license?.plate_number }}</div>
            <div class="detail-text">PICKUP: {{ selectedResult.pick_up }}</div>
            <div class="detail-text">DROP OFF: {{ selectedResult.drop_off  }}</div>
            <div class="border-dashed mt-3 mb-3"></div>

            <!-- 卡號、卡種、到期日等 -->
            <div class="detail-text">CARD: **** **** **** {{ selectedResult.card_last_4_digits }}</div>
            <div class="detail-text mb-3">{{ selectedResult.card_type }}  EXP DATE: {{ selectedResult.exp_date }}</div>
            <div class="detail-text">TRANSACTION REF: {{ selectedResult.transaction_ref }}</div>

            <!-- Approved 狀態，金額等 -->
            <div class="approved-text mt-3 mb-3">Approved</div>

            <!-- 顯示三筆費用: fare, service_fee, service_gst -->
            <div class="row mb-2">
              <div class="col-7 detail-text">FARE*</div>
              <div class="col-3 detail-text">AUD</div>
              <div class="col-2 detail-text">${{ selectedResult.approved.fare }}</div>
            </div>
            <div class="row mb-2">
              <div class="col-7 detail-text">SERVICE FEE</div>
              <div class="col-3 detail-text">AUD</div>
              <div class="col-2 detail-text">${{ selectedResult.approved.service_fee }}</div>
            </div>
            <div class="row mb-2">
              <div class="col-7 detail-text">SERVICE GST</div>
              <div class="col-3 detail-text">AUD</div>
              <div class="col-2 detail-text">${{ selectedResult.approved.service_gst }}</div>
            </div>

            <!-- 總計，可自行計算 (fare + fee + gst) 或後端回傳 -->
            <div class="row mb-3">
              <div class="col-7 total-text">TOTAL</div>
              <div class="col-3 total-text">AUD</div>
              <div class="col-2 total-text">
                ${{ selectedResult.approved.total  }}
              </div>
            </div>
            <div class="detail-text">*Fare is inclusive of GST and passenger levy $1.32 (GST inclusive).</div>
          </div>
        </div>

      </div> <!-- row end -->
    </div> <!-- container end -->
  </div> <!-- main end -->
</template>

<script setup>
import { ref } from 'vue'
import { useReceiptStore } from '@/store/driver/receipt'
import Datepicker1 from '@vuepic/vue-datepicker';
import Swal from 'sweetalert2'

const receiptStore = useReceiptStore()

// 分頁 / 步驟控制
const step = ref(1)
// 用來儲存使用者點選後，要顯示詳細資料的那筆資料
const selectedResult = ref(null)

const format = (date) => {
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}


// 搜尋
const search = async () => {
  if (!receiptStore.filters.date || !receiptStore.filters.amount || !receiptStore.filters.card_last_4_digits) {
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'Please fill in all the required fields.',
    })
    return
  }
  await receiptStore.fetchTransactions()  // 這裡會更新 receiptStore.results
  step.value = 1  // 回到列表頁，顯示新的結果
  selectedResult.value = null // 清除舊的明細
}


// 切換步驟
const stepTo = (newStep) => {
  step.value = newStep
  // 如果回到 step=1，清空 selectedResult
  if (newStep === 1) {
    selectedResult.value = null
  }
}

// 點選某筆紀錄，進入詳細 (step=2)
const goToDetail = (result) => {
  selectedResult.value = result
  step.value = 2
}
function formatDateTime(datetimeStr) {
  // 假設 datetimeStr 格式為 "YYYY-MM-DD HH:mm:ss"
  const [datePart, timePart] = datetimeStr.split(' ');
  const [year, month, day] = datePart.split('-');
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const shortMonth = monthNames[parseInt(month, 10) - 1] || month;
  const shortYear = year.slice(-2);
  const [hour, minute] = timePart.split(':');
  return `${day}/${shortMonth}/${shortYear}, ${hour}:${minute}`;
}


function parseDate(datetimeStr) {
  const [datePart] = datetimeStr.split(' ');
  const [year, month, day] = datePart.split('-');

  return `${day}/${month}/${year.slice(-2)}`;
}
function parseTime(datetimeStr) {
  const [, timePart] = datetimeStr.split(' '); 
  const [hour, minute] = timePart.split(':');
  return `${hour}:${minute}`;
}


const downloadReceipt = () => {
  // 取得收據明細的 outerHTML（包含外層容器，方便覆蓋尺寸）
  const printContents = document.getElementById('receipt-detail').outerHTML;

  // 取得目前頁面中所有 link 與 style 樣式
  const styles = Array.from(
    document.querySelectorAll('link[rel="stylesheet"], style')
  )
    .map((el) => el.outerHTML)
    .join('');

  // 定義列印專用的 CSS：以 A4 輸出、設定頁面邊距為 0，
  // 並將收據區 (#receipt-detail) 固定尺寸為 寬 6cm、高 12cm，且居中顯示
  const printStyleOverrides = `
    <style>
      @page {
        margin: 5px;
        size: 6.8cm 16cm;
        margin: 0;
        border: 2px solid black;
      }
      /* 覆蓋 #receipt-detail 的尺寸 */
      #receipt-detail {
        width: 6cm;
        height: 12cm;
      }
    </style>
  `;

  // 開啟新視窗，並將原有樣式與列印覆蓋樣式與收據內容一起寫入
  const printWindow = window.open('', '', 'width=600,height=800');
  printWindow.document.open();
  printWindow.document.write(`
    <html>
      <head>
        <title>Receipt</title>
        ${styles}
        ${printStyleOverrides}
      </head>
      <body>
        ${printContents}
      </body>
    </html>
  `);
  printWindow.document.close();
  printWindow.focus();

  // 延遲 500 毫秒後執行列印，確保內容與樣式載入完成
  setTimeout(() => {
    printWindow.print();
    printWindow.close();
  }, 500);
};


</script>

<style scoped>
input{
  height: 50px;
  border-radius: 0px;
}

select{
  height: 50px;
  border-radius: 0px;
}

.find-your-reciept {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: #020816;
  height: 20vh;
  color: white;
}

.find-your-reciept-title {
  padding-top: 40px;
  font-family: 'Euclid Square', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 42px;
  line-height: 42px;
}

.find-your-reciept-text {
  padding-top: 20px;
  font-family: 'Mulish', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 40px;
}

.main {
  width: 100%;
  min-height: 71.5vh;
  background-color: #e6e9ec;
}

.bg-search{
  background-color: #eef1f4;
  padding: 80px;
}

.search-text{
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 800;
  font-size: 14px;
  line-height: 19px;

  color: #051C2C;
}

.btn-search{
  width: 180px;
  height: 50px;
  background: #5248DA;
  color: white;
  font-size: 16px;
  border-radius: 0px;
}

.result-text{
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: #051C2C;
}


.result-amount{
  font-family: 'Euclid Square';
  font-style: normal;
  font-weight: 400;
  font-size: 21px;
  line-height: 27px;
  color: #051C2C;
}

.btn-arrow {
  width: 25px;
  height: 25px;
  
  display: inline-flex;
  align-items: center;
  justify-content: center;
  
  padding: 0;
}
.arrow-icon {
  width: 100%;
  height: 100%;
  object-fit: contain; 
}

.btn-back{
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: #5248DA;
  border: none;
}

.btn-back:hover{
  color: #5248DA;
  text-decoration: underline;
}

.back-icon{
  width: 16px;
  height: 16px;
  object-fit: contain;
}

.download-box{
 margin-top: 20px;
 display: flex;
 align-items: center;
 justify-content: center;
 width: 100%;
 height: 50px;
 color: white;
 background-color: #00c962;
}

.download-icon{
  width: 16px;
  height: 16px;
  object-fit: contain;
}

.logo-icon{
  width: 120px;
  object-fit: contain;
}

.taxi1-pty{
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 20px;
  text-align: center;
  margin-top: 5px;
  color: #051C2C;
}

.tax-invoice{
  margin-top: 15px;
  margin-bottom: 10px;
  font-family: 'Euclid Square';
  font-style: normal;
  font-weight: 700;
  font-size: 23px;
  line-height: 29px;
  text-align: center;
  color: #051C2C;
}

.detail-text{
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: #051C2C;
}

.border-dashed {
  border-top: 1.5px dashed #051C2C; /* 可依需求調整顏色或粗細 */
}

.approved-text{
  font-family: 'Euclid Square';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 20px;

  color: #051C2C;
}

.total-text{
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  color: #051C2C;
}

.no-result{
  height: 100px;
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #FF4040;
}

@media screen and (max-width: 768px) {
  .find-your-reciept{
    height: 35vh;
  }

  .find-your-reciept-text{
    padding: 25px;
  }
}
</style>
